export default __webpack_public_path__ + "static/media/marauders-map-v5.0-03-02.fe880921.jpg";